export default __webpack_public_path__ + "static/media/com-diamond.31facdce.mp4";